import { deepFreeze } from '../../utils/misc_utils';

export const ReturnReasonEnum = deepFreeze({
    UNKNOWN: {
        value: 'UNKNOWN',
        label: 'Błąd'
    },
    PRODUCT_THEFT: {
        value: 'PRODUCT_THEFT',
        label: 'Kradzież produktu'
    },
    DAMAGED_PRODUCT: {
        value: 'DAMAGED_PRODUCT',
        label: 'Uszkodzenie produktu'
    },
    POOR_PRODUCT_QUALITY: {
        value: 'POOR_PRODUCT_QUALITY',
        label: 'Zła jakość produktu'
    },
    OTHER: {
        value: 'OTHER',
        label: 'Inny'
    }
});